// Items::SerializeCollection#build_meta echoes `params['page']` back verbatim, so currentPage
// (and perPage, depending on the path) arrive as STRINGS for query-param-driven requests.
// Strings break PaginationCard: '2' + 1 concatenates to '21' and the strict first/last-page
// checks never match. Normalize every numeric meta field before it reaches the store.
const toNumber = (value) => {
  if (value === '' || value === null || value === undefined) {
    return undefined
  }
  const number = Number(value)
  return Number.isFinite(number) ? number : undefined
}

const normalizeMeta = (meta) => {
  if (!meta || typeof meta !== 'object') {
    return {}
  }

  return {
    ...meta,
    totalCount: toNumber(meta.totalCount),
    currentPage: toNumber(meta.currentPage),
    totalPages: toNumber(meta.totalPages),
    perPage: toNumber(meta.perPage),
  }
}

export default normalizeMeta
